import { DownloadIcon, EditIcon, PDFIcon, TrashIcon } from '../../../../../../assets/icons/common';
import { DOCUMENT_FILE_TYPES, DOCUMENT_UPLOAD_HINT } from '../../../constants';
import InfoCard from '../../../components/InfoCard';
import DropBox from '../../../../../../containers/DropBox';
import { DocumentSlot } from '../../../types';
import styles from './style.module.scss';
import { useState } from 'react';

interface Props {
    slot: DocumentSlot;
    /** Name of the document stored on the profile, empty while there is none. */
    fileName: string;
    isEditing: boolean;
    uploading: boolean;
    onEdit: () => void;
    onDelete: () => void;
    onDownload: () => void;
    onUpload: (file: File) => void;
};

/** One document slot: what is on file, and the drop box to replace it. */
function DocumentCard(props: Props) {
    const { slot, fileName, isEditing, uploading, onEdit, onDelete, onDownload, onUpload } = props;
    const [file, setFile] = useState<File | null>(null);

    return (
        <InfoCard
            title={slot.title}
            actions={<>
                <EditIcon onClick={onEdit} />
                {fileName && <>
                    <TrashIcon onClick={onDelete} />
                    <DownloadIcon onClick={onDownload} />
                </>}
            </>}
        >
            {fileName && <div className={styles.file}>
                <PDFIcon />
                <span className={styles.file_title}>{fileName}</span>
            </div>}

            {!fileName && !isEditing && <span className={styles.noData}>No file.</span>}

            {isEditing && <DropBox
                file={file}
                setFile={setFile}
                uploading={uploading}
                fileTypes={DOCUMENT_FILE_TYPES}
                description={DOCUMENT_UPLOAD_HINT}
                uploadFunc={() => file && onUpload(file)}
            />}
        </InfoCard>
    );
};

export default DocumentCard;
